import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "knowledge-base-dropdown-filters";

const keys = addTranslations(RESOURCE_NAME, {
    type_zero: {
        en: "Type",
        fr: "Type",
    },
    type: {
        en: "Type",
        fr: "Type",
    },
    type_other: {
        en: "Types",
        fr: "Types",
    },
    status_zero: {
        en: "Status",
        fr: "Statut",
    },
    status: {
        en: "Status",
        fr: "Statut",
    },
    status_other: {
        en: "Statuses",
        fr: "Statuts",
    },
    entity_zero: {
        en: "Entity",
        fr: "Entité",
    },
    entity: {
        en: "Entity",
        fr: "Entité",
    },
    entity_other: {
        en: "Entities",
        fr: "Entités",
    },
    reset: {
        en: "Reset",
        fr: "Réinitialiser",
    },
    POLICY: {
        en: "Policy",
        fr: "Politique",
    },
    MEASURE: {
        en: "Measure",
        fr: "Mesure",
    },
    CUSTOM: {
        en: "Custom Document",
        fr: "Document spécifique",
    },
    TODO: {
        en: "To do",
        fr: "À faire",
    },
    IN_PROGRESS: {
        en: "In progress",
        fr: "En cours",
    },
    DONE: {
        en: "Validated",
        fr: "Validé",
    },
});

export function useKnowledgeBaseDropdownFilterTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
